import App from './App.svelte';
import './firebase'

import 'bootswatch/dist/minty/bootstrap.min.css';

const app = new App({
	target: document.body,
	props: {
		
	}
});

export default app;